import React, { useState, useRef, useEffect } from 'react';
import './TooltipComponent.css';

type TooltipProps = {
  text: string;
  tooltipText: string;
};

const TooltipComponent: React.FC<TooltipProps> = ({ text, tooltipText }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const textRef = useRef<HTMLDivElement>(null);

  // Calculate position when hover state changes
  useEffect(() => {
    if (isHovered && textRef.current) {
      const rect = textRef.current.getBoundingClientRect();
      setTooltipPosition({
        // Position above the element instead of below
        top: rect.top - 2, // 10px above the element
        left: rect.left  -8
      });
    }
  }, [isHovered]);

  return (
    <div className="tooltip-component tooltip-container">
      <div 
        ref={textRef}
        className="tooltip-text"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {text}
      </div>
      {isHovered && (
        <div 
          className="tooltip-callout" 
          style={{ 
            top: `${tooltipPosition.top}px`, 
            left: `${tooltipPosition.left}px` 
          }}
        >
          {tooltipText}
        </div>
      )}
    </div>
  );
};

export default TooltipComponent;